export enum PaymentStatuses {
    STATUS_PAYMENT_HAS_NOT_BEEN_EXECUTED = 'not_executed',
    STATUS_PAYMENT_ORDER_ACCEPTED_BUT_NOT_YET_EXECUTED = 'waiting_confirmation',
    STATUS_PAYMENT_SUCCESSFUL = 'succeeded',
    STATUS_PAYMENT_WAS_EXECUTED_BUT_CONFIRMATION_WONT_BE_SENT = 'executed_but_confirmation_wont_be_sent',
}